import { useAIChat } from '@/hooks/useAIChat';
import { AIChatHeader } from '@/components/ai-chat/AIChatHeader';
import { AIChatMessages } from '@/components/ai-chat/AIChatMessages';
import { AIChatInput } from '@/components/ai-chat/AIChatInput';

interface AIChatInlineProps {
  matchProfile: {
    id: string;
    displayName: string;
    photos?: Array<{ url: string; order?: number }> | null;
  };
  matchId: string;
  onClose: () => void;
}

export function AIChatInline({ matchProfile, matchId, onClose }: AIChatInlineProps) {
  const {
    messages,
    isStreaming,
    streamingContent,
    photoAnalysis,
    sendMessageStreaming,
    cancelStream,
    endSession,
  } = useAIChat({
    contextType: 'messaging',
    contextProfileId: matchProfile.id,
    contextMatchId: matchId,
    analyzePhotos: false,
  });

  const profileContext = {
    profileId: matchProfile.id,
    displayName: matchProfile.displayName,
    photos: matchProfile.photos?.map(p => ({ url: p.url })),
  };

  const handleClose = () => {
    endSession(); // End session when closing
    onClose();
  };

  return (
    <div className="flex flex-col h-full bg-transparent">
      <AIChatHeader
        profile={profileContext}
        photoAnalysis={photoAnalysis}
        compact
        onClose={handleClose}
      />
      <AIChatMessages
        messages={messages}
        isStreaming={isStreaming}
        streamingContent={streamingContent}
      />
      <AIChatInput
        onSend={sendMessageStreaming}
        onCancel={cancelStream}
        isLoading={false}
        isStreaming={isStreaming}
        placeholder={`Ask about ${matchProfile.displayName}...`}
      />
    </div>
  );
}
